import { DEFAULT_ALL_OPTION } from '_/utils/constants'

export const FILTER_OPTIONS = {
  AGENCY: 'agency',
  CITY: 'city',
  STEP_STATUS: 'stepStatus',
  FULL_ADDRESS: 'fullAddress',
  PROPERTY_CODE: 'code',
  REQUESTER_DATA: 'requesterData',
  RESPONSIBLE: 'responsible',
  SERVICE_ORDER_ID: 'serviceOrder',
  TRADESMAN: 'tradesman',
  CLASSIFICATION: 'classification',
  SITUATION: 'situation',
  SERVICEORDER_STATUS: 'statusServiceOrder',
  IS_EMERGENCY: 'emergency',
  PRIORITY: 'priority',
  BUILDING_CONTAINS: 'buildingContains',
  OPEN_BETWEEN: 'openBetween',
  SERVICE_CLOSED_BETWEEN: 'serviceClosedBetween',
  SERVICE_ORDER_CANCELED_BETWEEN: 'serviceOrderCanceledBetween',
  OPEN_BETWEEN_START: 'openBetweenStart',
  SERVICE_CLOSED_BETWEEN_START: 'serviceClosedBetweenStart',
  SERVICE_ORDER_CANCELED_BETWEEN_START: 'serviceOrderCanceledBetweenStart',
  OPEN_BETWEEN_END: 'openBetweenEnd',
  SERVICE_CLOSED_BETWEEN_END: 'serviceClosedBetweenEnd',
  SERVICE_ORDER_CANCELED_BETWEEN_END: 'serviceOrderCanceledBetweenEnd',
  ACCOUNT_MANAGER: 'accountManager',
}

export const INTERVAL_DATE_FILTERS = [
  FILTER_OPTIONS.OPEN_BETWEEN,
  FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN,
  FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN,
]

export const PROVISORY_INTERVAL_DATE_FILTERS = [
  FILTER_OPTIONS.OPEN_BETWEEN_START,
  FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN_START,
  FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN_START,
  FILTER_OPTIONS.OPEN_BETWEEN_END,
  FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN_END,
  FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN_END,
]

export const SITUATION_OPTIONS = [
  { ...DEFAULT_ALL_OPTION },
  {
    value: 'active',
    label: 'Ativos',
  },
  {
    value: 'delayed',
    label: 'Atrasados',
  },
  {
    value: 'paused',
    label: 'Pausados',
  },
]

export const FILTER_OPTIONS_LABEL = {
  [FILTER_OPTIONS.AGENCY]: 'Por intermediária',
  [FILTER_OPTIONS.IS_EMERGENCY]: 'Cliente considera emergência',
  [FILTER_OPTIONS.CITY]: 'Por cidade do imóvel',
  [FILTER_OPTIONS.STEP_STATUS]: 'Por etapa',
  [FILTER_OPTIONS.SERVICEORDER_STATUS]: 'Status do chamado',
  [FILTER_OPTIONS.FULL_ADDRESS]: 'Por endereço',
  [FILTER_OPTIONS.PROPERTY_CODE]: 'Por código do imóvel',
  [FILTER_OPTIONS.REQUESTER_DATA]: 'Por solicitante',
  [FILTER_OPTIONS.RESPONSIBLE]: 'Responsável pelo chamado',
  [FILTER_OPTIONS.SERVICE_ORDER_ID]: 'Por ID do chamado',
  [FILTER_OPTIONS.TRADESMAN]: 'Por prestador',
  [FILTER_OPTIONS.CLASSIFICATION]: 'Por classificação',
  [FILTER_OPTIONS.SITUATION]: 'Por situação',
  [FILTER_OPTIONS.PRIORITY]: 'Por prioridade',
  [FILTER_OPTIONS.BUILDING_CONTAINS]: 'Empreendimento contenha',
  [FILTER_OPTIONS.OPEN_BETWEEN]: 'Aberto entre',
  [FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN]: 'Serviço finalizado entre',
  [FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN]: 'Chamado cancelado entre',
  [FILTER_OPTIONS.ACCOUNT_MANAGER]: 'Gerente de Carteira',
}

export const CLEAN_FILTER_VALUES = {
  [FILTER_OPTIONS.AGENCY]: '',
  [FILTER_OPTIONS.CITY]: '',
  [FILTER_OPTIONS.FULL_ADDRESS]: '',
  [FILTER_OPTIONS.PROPERTY_CODE]: '',
  [FILTER_OPTIONS.REQUESTER_DATA]: '',
  [FILTER_OPTIONS.RESPONSIBLE]: '',
  [FILTER_OPTIONS.SERVICE_ORDER_ID]: '',
  [FILTER_OPTIONS.STEP_STATUS]: '',
  [FILTER_OPTIONS.SERVICEORDER_STATUS]: '',
  [FILTER_OPTIONS.TRADESMAN]: '',
  [FILTER_OPTIONS.CLASSIFICATION]: '',
  [FILTER_OPTIONS.SITUATION]: '',
  [FILTER_OPTIONS.IS_EMERGENCY]: '',
  [FILTER_OPTIONS.PRIORITY]: '',
  [FILTER_OPTIONS.BUILDING_CONTAINS]: '',
  [FILTER_OPTIONS.OPEN_BETWEEN]: '',
  [FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN]: '',
  [FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN]: '',
  [FILTER_OPTIONS.OPEN_BETWEEN_START]: '',
  [FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN_START]: '',
  [FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN_START]: '',
  [FILTER_OPTIONS.OPEN_BETWEEN_END]: '',
  [FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN_END]: '',
  [FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN_END]: '',
  [FILTER_OPTIONS.ACCOUNT_MANAGER]: '',
}

export const FILTERS = [
  {
    name: FILTER_OPTIONS.STEP_STATUS,
    isTradesman: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.PRIORITY,
    isTradesman: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.SITUATION,
    isTradesman: true,
  },
  {
    name: FILTER_OPTIONS.SERVICE_ORDER_ID,
    isTextfield: true,
    isTradesman: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.PROPERTY_CODE,
    isTextfield: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.IS_EMERGENCY,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.CITY,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.REQUESTER_DATA,
    isTextfield: true,
    isTradesman: true,
    helperText: 'Busque por nome, email, telefone ou CPF/CNPJ',
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.RESPONSIBLE,
    isTradesman: false,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.TRADESMAN,
    isTextfield: true,
    helperText: 'Busque por nome da empresa, responsável, telefone e e-mail do prestador',
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.CLASSIFICATION,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.AGENCY,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.FULL_ADDRESS,
    isTextfield: true,
    isTradesman: true,
    helperText: 'Busque por rua, número, bairro, cidade, estado ou complemento',
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.SERVICEORDER_STATUS,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.ACCOUNT_MANAGER,
    isIntermediary: true,
  },
].map(value => ({
  ...value,
  label: FILTER_OPTIONS_LABEL[value.name],
}))

export const MAIN_FILTERS = [
  {
    name: FILTER_OPTIONS.SERVICE_ORDER_ID,
    isTextfield: true,
    isTradesman: true,
    isAdmin: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.STEP_STATUS,
    isTradesman: true,
    isAdmin: true,
    isIntermediary: true,
    helperText:
      'Este filtro só mostra etapas que tenham chamados. Se uma etapa não for exibida, entenda que não há mais chamados nela.',
  },
  {
    name: FILTER_OPTIONS.PRIORITY,
    isAdmin: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.BUILDING_CONTAINS,
    isIntermediary: true,
    isTextfield: true,
    shouldRender: ({ user }) => {
      return !!(
        user?.activeProfile?.intermediaryPerfil &&
        user?.agencyRelatedData?.areaOfActivity?.enterpriseManagement
      )
    },
  },
  {
    name: FILTER_OPTIONS.SITUATION,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.AGENCY,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.PROPERTY_CODE,
    isTextfield: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.REQUESTER_DATA,
    isTextfield: true,
    isIntermediary: true,
    helperText: 'Busque por nome, email, telefone ou CPF/CNPJ',
  },
  {
    name: FILTER_OPTIONS.TRADESMAN,
    isTextfield: true,
    isIntermediary: true,
    isAdmin: true,
    helperText: 'Busque por nome da empresa, responsável, telefone e e-mail do prestador.',
  },
  {
    name: FILTER_OPTIONS.RESPONSIBLE,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.CLASSIFICATION,
    isAdmin: true,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.SERVICEORDER_STATUS,
    isIntermediary: true,
    isAdmin: true,
  },
].map(value => ({
  ...value,
  label: FILTER_OPTIONS_LABEL[value.name],
}))

export const SECONDARY_FILTERS = [
  {
    name: FILTER_OPTIONS.PROPERTY_CODE,
    isTextfield: true,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.REQUESTER_DATA,
    isTextfield: true,
    isAdmin: true,
    helperText: 'Busque por nome, email, telefone ou CPF/CNPJ',
  },
  {
    name: FILTER_OPTIONS.IS_EMERGENCY,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.OPEN_BETWEEN,
    isIntermediary: true,
    isAdmin: true,
    isDataRange: true,
  },
  {
    name: FILTER_OPTIONS.SERVICE_CLOSED_BETWEEN,
    isIntermediary: true,
    isAdmin: true,
    isDataRange: true,
  },
  {
    name: FILTER_OPTIONS.SERVICE_ORDER_CANCELED_BETWEEN,
    isIntermediary: true,
    isAdmin: true,
    isDataRange: true,
  },
  {
    name: FILTER_OPTIONS.IS_EMERGENCY,
    isIntermediary: true,
  },
  {
    name: FILTER_OPTIONS.CITY,
    isIntermediary: true,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.REQUESTER_DATA,
    isTextfield: true,
    isTradesman: true,
    helperText: 'Busque por nome, email, telefone ou CPF/CNPJ',
  },
  {
    name: FILTER_OPTIONS.FULL_ADDRESS,
    isTextfield: true,
    isTradesman: true,
    isIntermediary: true,
    isAdmin: true,
    helperText: 'Busque por rua, número, bairro, cidade, estado ou complemento',
  },
  {
    name: FILTER_OPTIONS.RESPONSIBLE,
    isAdmin: true,
  },
  {
    name: FILTER_OPTIONS.ACCOUNT_MANAGER,
    isIntermediary: true,
  },
].map(value => ({
  ...value,
  label: FILTER_OPTIONS_LABEL[value.name],
}))

export const TABS = {
  MAIN: 'main',
  SECONDARY: 'secondary',
}

export const FILTER_TABS = {
  [TABS.MAIN]: {
    id: TABS.MAIN,
    label: 'Filtros principais',
    filters: MAIN_FILTERS,
  },
  [TABS.SECONDARY]: {
    id: TABS.SECONDARY,
    label: 'Mais filtros',
    filters: SECONDARY_FILTERS,
  },
}

export const SERVICE_ORDER_STATUS_FIELDS = [
  { ...DEFAULT_ALL_OPTION },
  {
    value: 'isActive',
    label: 'Chamados ativos',
  },
  {
    value: 'service_order_finished',
    label: 'Chamados finalizados',
  },
  {
    value: 'service_order_canceled',
    label: 'Chamados cancelados',
  },
]

export const EMERGENCY_OPTIONS = [
  {
    value: true,
    label: 'Sim',
  },
  {
    value: false,
    label: 'Não',
  },
]

export const PRIORITY_OPTIONS = [
  { ...DEFAULT_ALL_OPTION },
  {
    value: 'emergency',
    label: 'Fluxo emergencial',
  },
  {
    value: 'urgent',
    label: 'Emergência',
  },
  {
    value: 'high',
    label: 'Urgente',
  },
  {
    value: 'average',
    label: 'Normal',
  },
]
